import { render, staticRenderFns } from "./AdminUpdate.vue?vue&type=template&id=13a0b43a&scoped=true"
import script from "./AdminUpdate.vue?vue&type=script&lang=js"
export * from "./AdminUpdate.vue?vue&type=script&lang=js"
import style0 from "./AdminUpdate.vue?vue&type=style&index=0&id=13a0b43a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a0b43a",
  null
  
)

export default component.exports